import { ButtonPrimary, skinVars, Text1, Box, BoxedRow, Tag, Image, HighlightedCard } from '@telefonica/mistica';
import './index.scss';
import { t } from 'i18next';
import { TrackingEvents } from '../../utils/dataTransformation/tracking';
import { isWebviewIOS, isWebviewAndroid } from '../../utils/navigation/controlDevices';
import navigateParams from '../../utils/navigation/navigateParams';
import { useEffect, useState } from 'react';
import { managementEnvironment } from '../../utils/dataTransformation/environments';

interface ICardTab {
    image: string;
    tag: string;
    title: string;
    url: string;
    enabled: boolean;
    descriptionText?: string;
    idTrackingCard?: string;
}

export const CardsHome = ({ product }: { product: string }) => {
    const { trackingUserInteraction } = new TrackingEvents();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const convergentBlueMovistarPlus = managementEnvironment().REACT_APP_WEBVIEW_BLUETV_CONVERGENT_ENABLED;
    const convergentBlueAddLineMobile = managementEnvironment().REACT_APP_WEBVIEW_BLUEADDLINE_CONVERGENT_ENABLED;
    const convergentBlueDevices = managementEnvironment().REACT_APP_WEBVIEW_BLUEDEVICES_CONVERGENT_ENABLED;
    const convergentMosvistarPlus = managementEnvironment().REACT_APP_WEBVIEW_TV_CONVERGENT_ENABLED;
    const convergentDevices = managementEnvironment().REACT_APP_WEBVIEW_DEVICES_CONVERGENT_ENABLED;
    const convergentO2Cloud = managementEnvironment().REACT_APP_WEBVIEW_O2CLOUD_CONVERGENT_ENABLED;
    const convergentRates = managementEnvironment().REACT_APP_WEBVIEW_RATES_CONVERGENT_ENABLED;
    const convergentAddLineMobile = managementEnvironment().REACT_APP_WEBVIEW_ADDLINE_CONVERGENT_ENABLED;
    const mobileBlueMovistarPlus = managementEnvironment().REACT_APP_WEBVIEW_BLUETV_MOBILE_ENABLED;
    const mobileBlueGoConvergent = managementEnvironment().REACT_APP_WEBVIEW_BLUEGOCONVERGENT_MOBILE_ENABLED;
    const mobileBlueDevices = managementEnvironment().REACT_APP_WEBVIEW_BLUEDEVICES_MOBILE_ENABLED;
    const mobileMosvistarPlus = managementEnvironment().REACT_APP_WEBVIEW_TV_MOBILE_ENABLED;
    const mobileDevices = managementEnvironment().REACT_APP_WEBVIEW_DEVICES_MOBILE_ENABLED;
    const mobileO2Cloud = managementEnvironment().REACT_APP_WEBVIEW_O2CLOUD_MOBILE_ENABLED;
    const mobileRates = managementEnvironment().REACT_APP_WEBVIEW_RATES_MOBILE_ENABLED;
    const mobileAddLineMobile = managementEnvironment().REACT_APP_WEBVIEW_ADDLINE_MOBILE_ENABLED;
    const fiberBlueMovistarPlus = managementEnvironment().REACT_APP_WEBVIEW_BLUETV_FIBER_ENABLED;
    const fiberBlueGoConvergent = managementEnvironment().REACT_APP_WEBVIEW_BLUEGOCONVERGENT_FIBER_ENABLED;
    const fiberBlueDevices = managementEnvironment().REACT_APP_WEBVIEW_BLUEDEVICES_FIBER_ENABLED;
    const fiberMosvistarPlus = managementEnvironment().REACT_APP_WEBVIEW_TV_FIBER_ENABLED;
    const fiberDevices = managementEnvironment().REACT_APP_WEBVIEW_DEVICES_FIBER_ENABLED;
    const fiberO2Cloud = managementEnvironment().REACT_APP_WEBVIEW_O2CLOUD_FIBER_ENABLED;
    const fiberRates = managementEnvironment().REACT_APP_WEBVIEW_RATES_FIBER_ENABLED;
    const fiberAddLineMobile = managementEnvironment().REACT_APP_WEBVIEW_ADDLINE_FIBER_ENABLED;

    const cardsConvergent: ICardTab[] = [
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_80x115_2x.png',
            tag: t('cardTelevisionTagText'),
            url: process.env.REACT_APP_WEBVIEW_O2TELEVISION as string,
            title: t('titleCardTvHome'),
            enabled: convergentMosvistarPlus,
            descriptionText: t('descriptionTextCardTvHome'),
            idTrackingCard: 'card_tv__convergent_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_80x115.jpg',
            tag: t('devicesExplore'),
            url: process.env.REACT_APP_WEBVIEW_DEVICES as string,
            title: t('titleCardDevices'),
            enabled: convergentDevices,
            descriptionText: t('exploreBoxedRowMobilesDescription'),
            idTrackingCard: 'card_devices_convergent_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/cloud2x.png',
            tag: t('tagCardO2CloudHome'),
            url: process.env.REACT_APP_WEBVIEW_O2CLOUD as string,
            title: t('exploreBoxedRowTagO2cloud'),
            enabled: convergentO2Cloud,
            descriptionText: t('descriptionTextCardO2CloudHome'),
            idTrackingCard: 'card_o2_cloud_convergent_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/tarifas2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_POSTSALES as string,
            title: t('titleCardPostsalesHome'),
            enabled: convergentRates,
            descriptionText: t('descriptionTextCardPostsalesHome'),
            idTrackingCard: 'card_rates_convergent_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_lmas_80x115_2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_ADDITIONALLINE as string,
            title: t('cardFlexAddLineTitle'),
            enabled: convergentAddLineMobile,
            descriptionText: t('cardFlexAddLineDescription'),
            idTrackingCard: 'card_addline_convergent_tapped',
        },
    ];

    const cardsOnlyMobile: ICardTab[] = [
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_80x115_2x.png',
            tag: t('cardTelevisionTagText'),
            url: process.env.REACT_APP_WEBVIEW_O2TELEVISION as string,
            title: t('titleCardTvHome'),
            enabled: mobileMosvistarPlus,
            descriptionText: t('descriptionTextCardTvHome'),
            idTrackingCard: 'card_tv_mobile_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_80x115.jpg',
            tag: t('devicesExplore'),
            url: process.env.REACT_APP_WEBVIEW_DEVICES as string,
            title: t('titleCardDevices'),
            enabled: mobileDevices,
            descriptionText: t('exploreBoxedRowMobilesDescription'),
            idTrackingCard: 'card_devices_mobile_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/cloud2x.png',
            tag: t('tagCardO2CloudHome'),
            url: process.env.REACT_APP_WEBVIEW_O2CLOUD as string,
            title: t('exploreBoxedRowTagO2cloud'),
            enabled: mobileO2Cloud,
            descriptionText: t('descriptionTextCardO2CloudHome'),
            idTrackingCard: 'card_o2_cloud_mobile_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/tarifas2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_POSTSALES as string,
            title: t('titleCardPostsalesHome'),
            enabled: mobileRates,
            descriptionText: t('descriptionTextCardPostsalesHome'),
            idTrackingCard: 'card_rates_mobile_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_convergente_sm_80x115_2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_ADDITIONALLINE as string,
            title: t('cardFlexGoToConvergentTitle'),
            enabled: mobileAddLineMobile,
            descriptionText: t('cardFlexGoToConvergentDescription'),
            idTrackingCard: 'card_addline_mobile_tapped',
        },
    ];

    const cardsFiber: ICardTab[] = [
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_80x115_2x.png',
            tag: t('cardTelevisionTagText'),
            url: process.env.REACT_APP_WEBVIEW_O2TELEVISION as string,
            title: t('titleCardTvHome'),
            enabled: fiberMosvistarPlus,
            descriptionText: t('descriptionTextCardTvHome'),
            idTrackingCard: 'card_tv_fiber_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_80x115.jpg',
            tag: t('devicesExplore'),
            url: process.env.REACT_APP_WEBVIEW_DEVICES as string,
            title: t('titleCardDevices'),
            enabled: fiberDevices,
            descriptionText: t('exploreBoxedRowMobilesDescription'),
            idTrackingCard: 'card_devices_fiber_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/cloud2x.png',
            tag: t('tagCardO2CloudHome'),
            url: process.env.REACT_APP_WEBVIEW_O2CLOUD as string,
            title: t('exploreBoxedRowTagO2cloud'),
            enabled: fiberO2Cloud,
            descriptionText: t('descriptionTextCardO2CloudHome'),
            idTrackingCard: 'card_o2_cloud_fiber_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/tarifas2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_POSTSALES as string,
            title: t('titleCardPostsalesHome'),
            enabled: fiberRates,
            descriptionText: t('descriptionTextCardPostsalesHome'),
            idTrackingCard: 'card_rates_fiber_tapped',
        },
        {
            image: 'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_convergente_sf_80x115_2x.png',
            tag: t('rates'),
            url: process.env.REACT_APP_WEBVIEW_ADDITIONALLINE as string,
            title: t('cardFlexGoToConvergentTitle'),
            enabled: fiberAddLineMobile,
            descriptionText: t('cardFlexGoToConvergentDescription'),
            idTrackingCard: 'card_addline_fiber_tapped',
        },
    ];

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const filterCards = (): ICardTab[] => {
        const cards =
            product === 'convergent'
                ? cardsConvergent
                : product === 'mobile'
                ? cardsOnlyMobile
                : product === 'fiber'
                ? cardsFiber
                : [];
        const filteredCards: ICardTab[] = cards;
        cards.forEach((card: ICardTab, index: number) => {
            if (product === 'convergent') {
                if (!convergentMosvistarPlus && card.title === t('titleCardTvHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!convergentDevices && card.title === t('devicesExplore')) {
                    filteredCards.splice(index, 1);
                }
                if (!convergentO2Cloud && card.title === t('exploreBoxedRowTagO2cloud')) {
                    filteredCards.splice(index, 1);
                }
                if (!convergentRates && card.title === t('titleCardPostsalesHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!convergentAddLineMobile && card.title === t('cardFlexAddLineTitle')) {
                    filteredCards.splice(index, 1);
                }
            }

            if (product === 'mobile') {
                if (!mobileMosvistarPlus && card.title === t('titleCardTvHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!mobileDevices && card.title === t('devicesExplore')) {
                    filteredCards.splice(index, 1);
                }
                if (!mobileO2Cloud && card.title === t('exploreBoxedRowTagO2cloud')) {
                    filteredCards.splice(index, 1);
                }
                if (!mobileRates && card.title === t('titleCardPostsalesHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!mobileAddLineMobile && card.title === t('cardFlexAddLineTitle')) {
                    filteredCards.splice(index, 1);
                }
            }

            if (product === 'fiber') {
                if (!fiberMosvistarPlus && card.title === t('titleCardTvHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!fiberDevices && card.title === t('devicesExplore')) {
                    filteredCards.splice(index, 1);
                }
                if (!fiberO2Cloud && card.title === t('exploreBoxedRowTagO2cloud')) {
                    filteredCards.splice(index, 1);
                }
                if (!fiberRates && card.title === t('titleCardPostsalesHome')) {
                    filteredCards.splice(index, 1);
                }
                if (!fiberAddLineMobile && card.title === t('cardFlexAddLineTitle')) {
                    filteredCards.splice(index, 1);
                }
            }
        });
        return filteredCards;
    };

    const sendToNative = (url: string, type: string, title: string, id?: string) => {
        const storage = { id };
        const queryParams = { id };
        if (url === '/explore') {
            navigateParams(type, url, queryParams, storage, title, id);
        } else if (url === `${process.env.REACT_APP_WEBVIEW_O2CLOUD}`) {
            navigateParams(type, url, queryParams, storage, title, id, false);
        } else if (
            url === `${process.env.REACT_APP_WEBVIEW_DEVICES}` ||
            `${process.env.REACT_APP_WEBVIEW_POSTSALES}` ||
            `${process.env.REACT_APP_WEBVIEW_ADDITIONALLINE}`
        ) {
            navigateParams(type, url, queryParams, storage, title, id, false);
        } else if (url === `${process.env.REACT_APP_WEBVIEW_O2TELEVISION}`) {
            navigateParams(type, url, queryParams, storage, t('cardTelevisionTagText'), id, false);
        }
    };

    if (product === 'convergent') {
        return (
            <>
                {(isWebviewIOS || isWebviewAndroid) && (
                    <>
                        <div
                            className='cardsHome__blues'
                            style={{
                                padding:
                                    windowWidth >= 768
                                        ? convergentMosvistarPlus ||
                                          convergentDevices ||
                                          convergentO2Cloud ||
                                          convergentRates ||
                                          convergentAddLineMobile
                                            ? '32px'
                                            : '0 32px 24px'
                                        : windowWidth >= 375 &&
                                          (convergentMosvistarPlus ||
                                              convergentDevices ||
                                              convergentO2Cloud ||
                                              convergentRates ||
                                              convergentAddLineMobile)
                                        ? '0 16px 32px'
                                        : '0 16px 24px',
                            }}
                        >
                            {convergentBlueMovistarPlus && (
                                <div className='cardsHome__blueMovistarPlus'>
                                    <HighlightedCard
                                        title={t('blueCardNewTitle')!}
                                        description={t('blueCardNewSubtitle')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_convergent_movistar_plus_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_O2TELEVISION}`,
                                                        'modeModal-backgroundBlue',
                                                        t('cardTelevisionTagText'),
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {convergentBlueDevices && (
                                <div className='cardsHome__blueDevices'>
                                    <HighlightedCard
                                        title={t('titleCardDevices')!}
                                        description={t('exploreBoxedRowMobilesDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_app_100x168.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_devices_blue_go_convergent_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_DEVICES}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {convergentBlueAddLineMobile && (
                                <div className='cardsHome__blueAddLine'>
                                    <HighlightedCard
                                        title={t('cardFlexAddLineTitle')!}
                                        description={t('cardFlexAddLineDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_lmas_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction('card_convergent_addline_button_tapped');
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_ADDITIONALLINE}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {(convergentMosvistarPlus ||
                            convergentDevices ||
                            convergentO2Cloud ||
                            convergentRates ||
                            convergentAddLineMobile) && (
                            <div
                                className='cardsHome__featured'
                                style={{ background: skinVars.colors.backgroundSkeleton }}
                            >
                                <div className='cardsHome__featured-title'>
                                    <Text1 medium color={skinVars.colors.borderHigh}>
                                        {t('sectionFeaturedCards')}
                                    </Text1>
                                </div>
                                <div className='cardsHome__featured-cards'>
                                    {filterCards().map((card: ICardTab, key: number) => {
                                        const { image, tag, title, url, enabled, descriptionText, idTrackingCard } =
                                            card;
                                        if (enabled) {
                                            return (
                                                <Box
                                                    key={key}
                                                    paddingX={windowWidth >= 768 ? 32 : 16}
                                                    paddingBottom={8}
                                                >
                                                    <BoxedRow
                                                        asset={<Image src={image} width={80} aspectRatio='7:10' />}
                                                        headline={<Tag type='active'>{tag}</Tag>}
                                                        title={title}
                                                        description={descriptionText}
                                                        onPress={() => {
                                                            trackingUserInteraction(`${idTrackingCard}`);
                                                            if (card.title === t('exploreBoxedRowTagO2cloud')) {
                                                                sendToNative(url, 'modeBrowser', '');
                                                            } else {
                                                                sendToNative(url, 'modeModal-backgroundBlue', title);
                                                            }
                                                        }}
                                                    ></BoxedRow>
                                                </Box>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }

    if (product === 'mobile') {
        return (
            <>
                {(isWebviewIOS || isWebviewAndroid) && (
                    <>
                        <div
                            className='cardsHome__blues'
                            style={{
                                padding:
                                    windowWidth >= 768
                                        ? mobileMosvistarPlus ||
                                          mobileDevices ||
                                          mobileO2Cloud ||
                                          mobileRates ||
                                          mobileAddLineMobile
                                            ? '32px'
                                            : '0 32px 24px'
                                        : windowWidth >= 375 &&
                                          (mobileMosvistarPlus ||
                                              mobileDevices ||
                                              mobileO2Cloud ||
                                              mobileRates ||
                                              mobileAddLineMobile)
                                        ? '0 16px 32px'
                                        : '0 16px 24px',
                            }}
                        >
                            {mobileBlueGoConvergent && (
                                <div className='cardsHome__blueAddLine'>
                                    <HighlightedCard
                                        title={t('cardFlexGoToConvergentTitle')!}
                                        description={t('cardFlexGoToConvergentDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_convergente_sm_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_mobile_blue_go_convergent_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_POSTSALES}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {mobileBlueDevices && (
                                <div className='cardsHome__blieDevices'>
                                    <HighlightedCard
                                        title={t('titleCardDevices')!}
                                        description={t('exploreBoxedRowMobilesDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_app_100x168.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_devices_blue_go_convergent_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_DEVICES}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {mobileBlueMovistarPlus && (
                                <div className='cardsHome__blueMovistarPlus'>
                                    <HighlightedCard
                                        title={t('blueCardNewTitle')!}
                                        description={t('blueCardNewSubtitle')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction('card_mobile_movistar_plus_button_tapped');
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_O2TELEVISION}`,
                                                        'modeModal-backgroundBlue',
                                                        t('cardTelevisionTagText'),
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {(mobileMosvistarPlus ||
                            mobileDevices ||
                            mobileO2Cloud ||
                            mobileRates ||
                            mobileAddLineMobile) && (
                            <div
                                className='cardsHome__featured'
                                style={{ background: skinVars.colors.backgroundSkeleton }}
                            >
                                <div className='cardsHome__featured-title'>
                                    <Text1 medium color={skinVars.colors.borderHigh}>
                                        {t('sectionFeaturedCards')}
                                    </Text1>
                                </div>
                                <div className='cardsHome__featured-cards'>
                                    {filterCards().map((card: ICardTab, key: number) => {
                                        const { image, tag, title, url, enabled, descriptionText, idTrackingCard } =
                                            card;
                                        if (enabled) {
                                            return (
                                                <Box
                                                    key={key}
                                                    paddingX={windowWidth >= 768 ? 32 : 16}
                                                    paddingBottom={8}
                                                >
                                                    <BoxedRow
                                                        asset={<Image src={image} width={80} aspectRatio='7:10' />}
                                                        headline={<Tag type='active'>{tag}</Tag>}
                                                        title={title}
                                                        description={descriptionText}
                                                        onPress={() => {
                                                            trackingUserInteraction(`${idTrackingCard}`);
                                                            if (card.title === t('exploreBoxedRowTagO2cloud')) {
                                                                sendToNative(url, 'modeBrowser', '');
                                                            } else {
                                                                sendToNative(url, 'modeModal-backgroundBlue', title);
                                                            }
                                                        }}
                                                    ></BoxedRow>
                                                </Box>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }

    if (product === 'fiber') {
        return (
            <div>
                {(isWebviewIOS || isWebviewAndroid) && (
                    <div>
                        <div
                            className='cardsHome__blues'
                            style={{
                                padding:
                                    windowWidth >= 768
                                        ? fiberMosvistarPlus ||
                                          fiberDevices ||
                                          fiberO2Cloud ||
                                          fiberRates ||
                                          fiberAddLineMobile
                                            ? '32px'
                                            : '0 32px 24px'
                                        : windowWidth >= 375 &&
                                          (fiberMosvistarPlus ||
                                              fiberDevices ||
                                              fiberO2Cloud ||
                                              fiberRates ||
                                              fiberAddLineMobile)
                                        ? '0 16px 32px'
                                        : '0 16px 24px',
                            }}
                        >
                            {fiberBlueGoConvergent && (
                                <div className='cardsHome__blueAddLine'>
                                    <HighlightedCard
                                        title={t('cardFlexGoToConvergentTitle')!}
                                        description={t('cardFlexGoToConvergentDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_convergente_sf_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_fiber_blue_go_convergent_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_POSTSALES}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {fiberBlueDevices && (
                                <div className='cardsHome__blieDevices'>
                                    <HighlightedCard
                                        title={t('titleCardDevices')!}
                                        description={t('exploreBoxedRowMobilesDescription')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/banner_terminales_app_100x168.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_devices_blue_go_convergent_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_DEVICES}`,
                                                        'modeModal-backgroundBlue',
                                                        '',
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                            {fiberBlueMovistarPlus && (
                                <div className='cardsHome__blueMovistarPlus'>
                                    <HighlightedCard
                                        title={t('blueCardNewTitle')!}
                                        description={t('blueCardNewSubtitle')}
                                        imageUrl={
                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/img_app_tv_200x336_2x.png'
                                        }
                                        isInverse={true}
                                        button={
                                            <ButtonPrimary
                                                small
                                                onPress={() => {
                                                    trackingUserInteraction(
                                                        'card_fiber_blue_movistar_plus_button_tapped',
                                                    );
                                                    sendToNative(
                                                        `${process.env.REACT_APP_WEBVIEW_O2TELEVISION}`,
                                                        'modeModal-backgroundBlue',
                                                        t('cardTelevisionTagText'),
                                                    );
                                                }}
                                            >
                                                {t('Entrar')}
                                            </ButtonPrimary>
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {(fiberMosvistarPlus || fiberDevices || fiberO2Cloud || fiberRates || fiberAddLineMobile) && (
                            <div
                                className='cardsHome__featured'
                                style={{ background: skinVars.colors.backgroundSkeleton }}
                            >
                                <div className='cardsHome__featured-title'>
                                    <Text1 medium color={skinVars.colors.borderHigh}>
                                        {t('sectionFeaturedCards')}
                                    </Text1>
                                </div>
                                <div className='cardsHome__featured-cards'>
                                    {filterCards().map((card: ICardTab, key: number) => {
                                        const { image, tag, title, url, enabled, descriptionText, idTrackingCard } =
                                            card;
                                        if (enabled) {
                                            return (
                                                <Box
                                                    key={key}
                                                    paddingX={windowWidth >= 768 ? 32 : 16}
                                                    paddingBottom={8}
                                                >
                                                    <BoxedRow
                                                        asset={<Image src={image} width={80} aspectRatio='7:10' />}
                                                        headline={<Tag type='active'>{tag}</Tag>}
                                                        title={title}
                                                        description={descriptionText}
                                                        onPress={() => {
                                                            trackingUserInteraction(`${idTrackingCard}`);
                                                            if (card.title === t('exploreBoxedRowTagO2cloud')) {
                                                                sendToNative(url, 'modeBrowser', '');
                                                            } else {
                                                                sendToNative(url, 'modeModal-backgroundBlue', title);
                                                            }
                                                        }}
                                                    ></BoxedRow>
                                                </Box>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }

    return <></>;
};
